import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./AppBootstrap.vue";
import router from "./router";
import createPortalVuetify from "./plugins/vuetify";
import { installLegacyStoreBridge } from "./plugins/legacyStoreBridge";
import { registerPortalServiceWorker } from "./registerServiceWorker";
import { getRuntimeConfiguration } from "@/helpers/Configuration/ConfigurationFileHelpers";
import { runtimeConfigurationKey } from "@/runtimeConfiguration";
import { initializePortalHttpClient } from "@/services/httpClient";
import { useAuthStore } from "@/stores/auth";
import { useConfigurationStore } from "@/stores/configuration";
// Side-effect import: applies the dayjs plugin extensions (relativeTime,
// minMax, isSameOrAfter) at startup so no module depends on import ordering.
import "@/helpers/Dates/DateHelpers";
import "@/assets/css/main.css";

async function bootstrap() {
  const runtimeConfiguration = await getRuntimeConfiguration();
  const app = createApp(App);
  const pinia = createPinia();

  app.use(pinia);
  installLegacyStoreBridge(app);

  const configurationStore = useConfigurationStore();
  configurationStore.setConfigurationContents(runtimeConfiguration);

  initializePortalHttpClient(runtimeConfiguration);

  const authStore = useAuthStore();
  authStore.restoreSession();

  app.use(router);
  app.use(createPortalVuetify(runtimeConfiguration.portalThemeVariables));
  app.provide(runtimeConfigurationKey, runtimeConfiguration);

  registerPortalServiceWorker();

  app.mount("#app");
}

void bootstrap();
